import React, { Component } from 'react'
import { TweenMax, Back, TimelineMax, Power2, Power4, Sine, TimelineLite } from 'gsap';
//import ScrollMagicOne from '../../ScrollMagic';
import ScrollMagicOne from 'ScrollMagic';
//require('animation.gsap');


export default class introHeader extends Component {
    
    componentDidMount(){
        //let el = this.divStdHeaderBgWrap;
        //let el1 = this.divHeroContent
        //console.log(el);
        // TweenMax.from(el, .8, {
        //     autoAlpha: 0,
        //     x: 0,
        //     y: 50,
        //     rotationX: -50,
        //     transformOrigin: "center 0%",
        //     ease: Back.easeOut
        // }, "-=0.4");


        // TweenMax.set(this.divHeroContent, {
        //     perspective: 500
        // });
        
        // TweenMax.to(this.divHeroContent, 1, {
        //     y: -200,
        //     opacity: 0,
        //     ease: Power1.easeOut
        // }, "-=1");

        TweenMax.set(this.divStdHeaderBgWrap, {
            transformPerspective: 1e3
        });
        
        TweenMax.set(this.divHeroContent, {
            perspective: 500
        })

            let i = new TimelineMax;

            i.set([this.divHeroListLineOne, this.divHeroListLineTwo], {
                autoAlpha: 1
            }).from(this.divHeroTitle, .8, {
                autoAlpha: 0,
                x: 0,
                y: 50,
                rotationX: -50,
                transformOrigin: "center 0%",
                delay: 2,
                ease: Back.easeOut
            }, "-=0.4").from(this.divHeroListLineOne, .3, {
                scaleX: 0,
                y: 25,
                ease: Power2.easeOut,
                transformOrigin: "center center"
            }, "-=0.8").from(this.divHeroListLineTwo, .3, {
                scaleX: 0,
                y: -25,
                ease: Power2.easeOut,
                transformOrigin: "center center"
            }, "-=0.8").from(this.divHeroList, .6, {
                y: 25,
                autoAlpha: 0,
                ease: Power2.easeOut
            }, "-=0.5").from(this.divStdHeaderBgWrap, 4, {
                rotationX: 25,
                autoAlpha: 0,
                y: 0,
                transformOrigin: "center 0%",
                ease: Power4.easeOut
            }, "-=2.2");



        //     var t = new TimelineLite;
            
        //     t.to(this.divStdHeaderBgWrap, 1, {
        //         scale: 1.5,
        //         opacity: .1,
        //         transformOrigin: "center center",
        //         ease: Sine.easeInOut
        //     }).to(this.divHeroContent, 1, {
        //         y: -200,
        //         opacity: 0,
        //         ease: Power1.easeOut
        //     }, "-=1");


            


        //     var controller = new ScrollMagicOne.Controller({
        //         globalSceneOptions: {
                
        //         }
        //       });


        //       //console.log(t);

        //    let sce = new ScrollMagicOne.Scene({
        //         triggerElement: this.divHero,
        //         triggerHook: 0,
        //         duration: "100%"
        //     });
        //      sce.setTween(t).addTo(controller);
        
    }
  render() {
    return (
        <section className="hero" ref={e=> this.divHero = e}>
            <div className="hero__content" ref={e => this.divHeroContent = e}>
                <h1 className="hero_title" ref={e => this.divHeroTitle = e}>A dynamic group of young creatives strongly driven by design. </h1>
                <div className="hero__list-wrap" ref={e => this.divHeroListWrap = e}>
                            <div className="hero__list-line"  ref={e => this.divHeroListLineOne = e}></div>
                                            <ul className="hero__list" ref={e => this.divHeroList = e}>
                                                            <li className="hero__list-item" ref={e => this.divHeroListItem = e}>ARCHITECTURE</li>
                                                            <li className="hero__list-item" ref={e => this.divHeroListItem = e}>INTERIOR</li>
                                                            <li className="hero__list-item" ref={e => this.divHeroListItem = e}>Products</li>
                                                            {/* <li ref={e => this.divHeroListItem = e} className="hero__list-item">A whole lot of fun</li> */}
                                                            
                                                    </ul>
                        
                        <div className="hero__list-line" ref={e => this.divHeroListLineTwo = e} ></div>
                    </div>
                </div>
                <div className="std-header__bg-wrap" ref={e => this.divStdHeaderBgWrap = e}>
                {/* <video poster="https://murraybrand.ie/wp-content/uploads/2017/01/murray-brand-home-1.jpg" ref={e => this.divStdHeaderBg = e} className="std-header__bg cover wp-post-image" autoPlay loop id="video-background" muted playsInline>
                    <source src="https://videos.valnetcdn.com/assets/videos/home.mp4" type="video/mp4" />
                    <img src="https://studiogritt.files.wordpress.com/2018/04/front.jpg" className="std-header__bg cover wp-post-image" alt="Murray Brand" srcset="https://murraybrand.ie/wp-content/uploads/2017/01/murray-brand-home-1.jpg 1750w, https://murraybrand.ie/wp-content/uploads/2017/01/murray-brand-home-1-768x404.jpg 768w, https://murraybrand.ie/wp-content/uploads/2017/01/murray-brand-home-1-875x459.jpg 875w, https://murraybrand.ie/wp-content/uploads/2017/01/murray-brand-home-1-1179x620.jpg 1179w" sizes="(max-width: 1750px) 100vw, 1750px" />
                </video> */}
                    <img src="https://studiogritt.files.wordpress.com/2018/04/front.jpg" className="std-header__bg cover wp-post-image" alt="Studio Gritt Team"  />
            </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/IntroHeader/index.js